import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import { camelizeKeys } from "lib/helpers";
import actions from "rdx/actions";

function* oauth(action) {
  const redirectPath = action?.payload?.redirectPath;
  const params = redirectPath ? { redirect_path: redirectPath } : {};
  const { success, data, error } = yield* makeRequest.get("/jwt/authorize", params);

  if (success && data) {
    yield all([put(actions.setAuthUri(camelizeKeys(data)))]);
  }
  if (error) {
    return error;
  }

  return null;
}

export default oauth;
